/* eslint-disable react/no-unknown-property */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ImageUrl } from "../../../utils/constants";
import {
  GetCompletedInitiatives,
  GetActiveCompletedRecurringInitiatives,
  GetCompletedInitiativesV2,
  GetCompletedRecurringInitiativesV2,
  GetArchivedCompanyInitiativesV2,
  GetArchivedRecurringInitiativesV2,
} from "../../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { fetchApi } from "../../../utils/methods";
import dayjs from "dayjs";
import SkeletonLoder from "../../common/skeletonLoder";
import { NoData } from "../styles";
import { CommonFilterDropdown } from "../../common/CommonYearFilter/CommonYearFilter";
import { InitiativesWrap, InitiativeCard } from '../../HealthDataManagement/styles';
import { NewDropDownIcon, RecognitionEyeIconNew } from '../../../utils/icons';
import DetailPopup from '../../HealthDataManagement/initiativeParticipantsInfo';
import styled from 'styled-components';
import { InterestCard } from "../../UserProfile/styles";
import ActiveInitiativeCard from '../../HealthDataManagement/ActiveInitiativeCard';

// ---------- Styled components ----------
const SectionHeader = styled.h3`
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 10px;
  color: #184A61;
  font-family: lato;
`;

const MonthHeader = styled.div`
  font-size: 18px;
  font-weight: bold;
  ${'' /* margin: 15px 0 10px; */}
  color: #184A61;
  ${'' /* padding: 8px 12px; */}
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-family: lato;
  .dropicon {
    transition: transform 0.3s ease;
    transform: ${(props) => (props.isOpen ? "rotate(360deg)" : "rotate(270deg)")};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

const InitiativeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 0px 0;
`;

const BorderCard = styled.div`
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
  width: 100%;
`;

const SubTabBar = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  ${'' /* border-bottom: 1px solid #EFEFEF; */}
`;

const SubTab = styled.div`
  font-size: 16px;
  font-family: Lato;
  font-weight: '400';
  color: #184A61;
  cursor: pointer;
  padding: 0 4px 10px 4px;
  margin-right: 24px;
  margin-bottom: -1px;
  border-bottom: 2px solid ${({ active }) => (active ? '#DA6C74' : 'transparent')};
  line-height: 20px;
`;

const WhiteContainer = styled.div`
  background: #FEFEFE;
  border-radius: 12px;
  border: 0.75px solid #DCDCDC;
  padding: 20px;
  margin-bottom: 20px;
`;

const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 24px;
  margin-top: 16px;
`;

class CompletedInitiative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: this.props.companyInfo.id,
      activeSubTab: 'completed',
      // Completed tab — one-time (new API)
      completedV2Data: [],
      completedV2Loading: false,
      // Completed tab — recurring (new API)
      completedRecurringData: [],
      completedRecurringLoading: false,
      // Archived tab — one-time
      archivedData: [],
      archivedLoading: false,
      // Archived tab — recurring
      archivedRecurringData: {},
      archivedRecurringLoading: false,
      archivedOpenMonths: [],
      archivedMonthFilter: "All Months",
      // Legacy state kept for old API (commented-out sections)
      completedInitiatives: [],
      year: new Date().getFullYear(),
      loading: false,
      showDetailPopup: false,
      detailInitiative: null,
      monthFilter: "All Months",
      oneOffInitiatives: [],
      recurringInitiatives: {},
      recurringLoading: false,
      allMonths: ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"],
      openMonths: [],
    };

    this.handleEyeIconClick = this.handleEyeIconClick.bind(this);
    this.handleMonthFilterChange = this.handleMonthFilterChange.bind(this);
    this.toggleMonth = this.toggleMonth.bind(this);
    this.toggleArchivedMonth = this.toggleArchivedMonth.bind(this);
  }

  componentDidMount() {
    this.fetchCompletedV2();
    this.fetchCompletedRecurring();
    this.fetchArchivedInitiatives();
    this.fetchArchivedRecurring();
    // Legacy calls kept for old sections (currently commented out in render)
    // this.getCompletedInitiatives(this.props.selectedYear);
    // this.getRecurringInitiatives(this.props.selectedYear);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedYear !== this.props.selectedYear) {
      // this.getCompletedInitiatives(this.props.selectedYear);
      // this.getRecurringInitiatives(this.props.selectedYear);
    }
    if (
      prevProps.selectedRewardPeriod !== this.props.selectedRewardPeriod &&
      this.props.selectedRewardPeriod?.reward_period_id
    ) {
      this.fetchCompletedV2();
      this.fetchCompletedRecurring();
      this.fetchArchivedInitiatives();
      this.fetchArchivedRecurring();
    }
  }

  fetchCompletedV2 = async () => {
    const { companyInfo, selectedRewardPeriod } = this.props;
    if (!companyInfo?.id || !selectedRewardPeriod?.reward_period_id) return;
    this.setState({ completedV2Loading: true });
    try {
      const res = await fetchApi(
        `${GetCompletedInitiativesV2}?company_id=${companyInfo.id}&reward_period_id=${selectedRewardPeriod.reward_period_id}`,
        'GET'
      );
      if (res.status === 'success') {
        this.setState({ completedV2Data: res.data || [] });
      }
    } catch { /* silent */ } finally {
      this.setState({ completedV2Loading: false });
    }
  };

  fetchArchivedInitiatives = async () => {
    const { companyInfo, selectedRewardPeriod } = this.props;
    if (!companyInfo?.id || !selectedRewardPeriod?.reward_period_id) return;
    this.setState({ archivedLoading: true });
    try {
      const res = await fetchApi(
        `${GetArchivedCompanyInitiativesV2}?company_id=${companyInfo.id}&reward_period_id=${selectedRewardPeriod.reward_period_id}`,
        'GET'
      );
      if (res.status === 'success') {
        this.setState({ archivedData: res.data || [] });
      }
    } catch { /* silent */ } finally {
      this.setState({ archivedLoading: false });
    }
  };

  fetchArchivedRecurring = async () => {
    const { companyInfo, selectedRewardPeriod } = this.props;
    if (!companyInfo?.id || !selectedRewardPeriod?.reward_period_id) return;
    this.setState({ archivedRecurringLoading: true });
    try {
      const res = await fetchApi(
        `${GetArchivedRecurringInitiativesV2}?company_id=${companyInfo.id}&reward_period_id=${selectedRewardPeriod.reward_period_id}`,
        'GET'
      );
      const months = res?.months || res?.data?.months || res?.data || [];
      this.processArchivedRecurring(months);
    } catch (e) { window.console.error(e); } finally {
      this.setState({ archivedRecurringLoading: false });
    }
  };

  handleArchivedMonthFilterChange = (selectedMonth) => {
    this.setState({ archivedMonthFilter: selectedMonth });
    if (selectedMonth === "All Months") {
      this.setState({ archivedOpenMonths: this.state.allMonths.filter((m) => this.state.archivedRecurringData[m]) });
    } else {
      this.setState({ archivedOpenMonths: [selectedMonth] });
    }
  };

  processArchivedRecurring = (data) => {
    const byMonth = {};
    const availableMonths = new window.Set();
    data.forEach((monthData) => {
      const month = monthData.month_name;
      if (monthData.initiatives && monthData.initiatives.length > 0) {
        byMonth[month] = monthData.initiatives;
        availableMonths.add(month);
      }
    });
    this.setState({
      archivedRecurringData: byMonth,
      archivedOpenMonths: Array.from(availableMonths),
    });
  };

  toggleArchivedMonth(month) {
    this.setState((prev) => {
      const { archivedOpenMonths } = prev;
      return archivedOpenMonths.includes(month)
        ? { archivedOpenMonths: archivedOpenMonths.filter((m) => m !== month) }
        : { archivedOpenMonths: [...archivedOpenMonths, month] };
    });
  }

  fetchCompletedRecurring = async () => {
    const { companyInfo, selectedRewardPeriod } = this.props;
    if (!companyInfo?.id || !selectedRewardPeriod?.reward_period_id) return;
    this.setState({ completedRecurringLoading: true });
    try {
      const res = await fetchApi(
        `${GetCompletedRecurringInitiativesV2}?company_id=${companyInfo.id}&reward_period_id=${selectedRewardPeriod.reward_period_id}`,
        'GET'
      );
      const months = res?.months || res?.data?.months || [];
      this.processRecurringInitiatives(months);
    } catch (e) { window.console.error(e); } finally {
      this.setState({ completedRecurringLoading: false });
    }
  };

  hideShowPopup = () => {
    this.setState({ showDetailPopup: false, detailInitiative: null });
  }

  showPopup = (data) => {
    this.setState({ showDetailPopup: true, detailInitiative: data });
  }

  handleEyeIconClick(e, initiative) {
    e.stopPropagation();
    e.preventDefault();
    this.showPopup(initiative);
  }

  // Legacy methods kept for old API (referenced by commented-out sections)
  getCompletedInitiatives = async (year) => {
    this.setState({ loading: true });
    const apiUrl = `${GetCompletedInitiatives}/${this.state.companyId}/${year}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        const initiatives = res?.data || [];
        this.processOneOffInitiatives(initiatives);
      } else {
        toast.error(res.error);
        this.setState({ loading: false });
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  getRecurringInitiatives = async (year) => {
    this.setState({ recurringLoading: true });
    const apiUrl = `${GetActiveCompletedRecurringInitiatives}/${this.state.companyId}/${year}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        const initiativesData = res?.data || [];
        this.processRecurringInitiatives(initiativesData);
      } else {
        toast.error(res.error);
        this.setState({ recurringLoading: false });
      }
    } catch (error) {
      this.setState({ recurringLoading: false });
    }
  };

  processOneOffInitiatives = (initiatives) => {
    const hasInitiativeType = initiatives.length > 0 &&
      Object.prototype.hasOwnProperty.call(initiatives[0], 'initiative_type');
    let oneOffInitiatives = [];
    if (hasInitiativeType) {
      oneOffInitiatives = initiatives.filter((i) => i.initiative_type === "one-off");
    } else {
      const recurringNames = ["Weight Loss", "Set Monthly Goal", "Financial Wellness Survey", "Preventive Exam"];
      initiatives.forEach((initiative) => {
        if (!recurringNames.includes(initiative.initiative_name)) oneOffInitiatives.push(initiative);
      });
    }
    this.setState({ oneOffInitiatives, loading: false });
  }

  processRecurringInitiatives = (initiativesData) => {
    const initiativesByMonth = {};
    const availableMonths = new window.Set();
    initiativesData.forEach((monthData) => {
      const month = monthData.month_name;
      if (monthData.initiatives && monthData.initiatives.length > 0) {
        initiativesByMonth[month] = monthData.initiatives;
        availableMonths.add(month);
      }
    });
    const currentMonth = dayjs().format("MMMM");
    const defaultMonthFilter = availableMonths.has(currentMonth) ? currentMonth : "All Months";
    const openMonths = Array.from(availableMonths);
    this.setState({ recurringInitiatives: initiativesByMonth, monthFilter: defaultMonthFilter, openMonths, recurringLoading: false });
  }

  handleMonthFilterChange = (selectedMonth) => {
    this.setState({ monthFilter: selectedMonth });
    if (selectedMonth === "All Months") {
      this.setState({ openMonths: this.state.allMonths.filter((month) => this.state.recurringInitiatives[month]) });
    } else {
      this.setState({ openMonths: [selectedMonth] });
    }
  }

  toggleMonth = (month) => {
    this.setState((prevState) => {
      const { openMonths } = prevState;
      return openMonths.includes(month)
        ? { openMonths: openMonths.filter((m) => m !== month) }
        : { openMonths: [...openMonths, month] };
    });
  }

  chunkArray = (arr, size) => (
    arr.reduce((acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc), [])
  );

  // ---------- Completed tab — One-Time section ----------
  renderOneTimeSection = () => {
    const { completedV2Data, completedV2Loading } = this.state;
    return (
      <WhiteContainer>
        <SectionHeader>One-Time</SectionHeader>
        {completedV2Loading ? (
          <SkeletonLoder width="100%" height="150px" />
        ) : (
          <CardGrid>
            {completedV2Data.length > 0 ? (
              completedV2Data.map((d, i) => (
                <ActiveInitiativeCard
                  key={i}
                  details={d}
                  hideBell
                  onCardClick={(item) =>
                    this.props.history?.push(
                      `/company/initiative-details/${item?.company_initiative_id || item?.id}`
                    )
                  }
                />
              ))
            ) : (
              <NoData>No completed one-time initiatives found</NoData>
            )}
          </CardGrid>
        )}
      </WhiteContainer>
    );
  };

  // ---------- Completed tab — Recurring section ----------
  renderRecurringNewSection = () => {
    const { recurringInitiatives, completedRecurringLoading, allMonths, monthFilter, openMonths } = this.state;
    const hasData = recurringInitiatives && Object.keys(recurringInitiatives).length > 0;
    const filterOptions = ["All Months", ...allMonths];
    const monthsToShow = monthFilter === "All Months" ? allMonths : [monthFilter];

    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <SectionHeader style={{ margin: 0 }}>Recurring</SectionHeader>
          {hasData && (
            <CommonFilterDropdown
              options={filterOptions}
              selectedOption={monthFilter}
              setSelectedOption={this.handleMonthFilterChange}
              dropdownWidth="150px"
              dropdownHeight="200px"
            />
          )}
        </div>
        {completedRecurringLoading ? (
          <SkeletonLoder width="100%" height="150px" />
        ) : !hasData ? (
          <NoData>No completed recurring initiatives found</NoData>
        ) : (
          monthsToShow.map((month) => {
            const monthInitiatives = recurringInitiatives[month] || [];
            const hasInitiatives = monthInitiatives.length > 0;
            const isOpen = openMonths.includes(month);
            return (
              <WhiteContainer key={month} style={{ marginBottom: '20px' }}>
                <MonthHeader isOpen={isOpen} onClick={() => this.toggleMonth(month)}>
                  <div>{month}</div>
                  <div className="dropicon"><NewDropDownIcon color="#F37A65" /></div>
                </MonthHeader>
                {isOpen && hasInitiatives && (
                  <CardGrid>
                    {monthInitiatives.map((d, i) => (
                      <ActiveInitiativeCard
                        key={i}
                        details={d}
                        hideBell
                        onCardClick={(item) =>
                          this.props.history?.push(
                            `/company/initiative-details/${item?.company_initiative_id || item?.id}`
                          )
                        }
                      />
                    ))}
                  </CardGrid>
                )}
                {isOpen && !hasInitiatives && (
                  <NoData>No Data Found For {month} Month</NoData>
                )}
              </WhiteContainer>
            );
          })
        )}
      </>
    );
  };

  // ---------- Old sections (kept, commented out below) ----------
  renderOldOneOffSection = () => {
    const { oneOffInitiatives, loading } = this.state;
    if (loading) {
      return (
        <div className="section">
          <SectionHeader>One-Off</SectionHeader>
          <div className='border' />
          <SkeletonLoder width={"100%"} height={"150px"} />
        </div>
      );
    }
    if (!oneOffInitiatives || oneOffInitiatives.length === 0) return null;
    const initiativeChunks = this.chunkArray(oneOffInitiatives, 3);
    return (
      <div className="section">
        <SectionHeader>One-Off ({oneOffInitiatives.length})</SectionHeader>
        <div className='border' />
        <div className="details">
          {initiativeChunks.map((chunk, chunkIndex) => (
            <React.Fragment key={`oneoff-chunk-${chunkIndex}`}>
              <InitiativeRow>
                {chunk.map((initiative, idx) => (
                  <div className="initiative-cards" key={`oneoff-${initiative.id || 'noid'}-${chunkIndex}-${idx}`}>
                    <InitiativeCard background={initiative?.color}>
                      <div className="icon">
                        <img src={`${ImageUrl}/${initiative.initiative_white_icon}`} alt={initiative.initiative_name} onError={(e) => { e.target.src = `${ImageUrl}/default-initiative.png`; }} />
                      </div>
                      <div className="wrap-content">
                        <div className="title">{initiative.initiative_name}</div>
                        <div className="completed">Completed on {dayjs(initiative.end_date).format("MMMM DD, YYYY")}</div>
                      </div>
                      <div id="hdm-eyeicon" className="end-container" onClick={(e) => this.handleEyeIconClick(e, initiative)} style={{ cursor: 'pointer' }}>
                        {RecognitionEyeIconNew()}
                      </div>
                    </InitiativeCard>
                  </div>
                ))}
              </InitiativeRow>
              {chunkIndex + 1 !== initiativeChunks?.length && <BorderCard />}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }

  renderOldRecurringSection = () => {
    const { recurringInitiatives, monthFilter, recurringLoading, allMonths, openMonths } = this.state;
    if (recurringLoading) {
      return (
        <div className="section">
          <SectionHeader>Recurring</SectionHeader>
          <div className='border' />
          <SkeletonLoder width={"100%"} height={"150px"} />
        </div>
      );
    }
    if (!recurringInitiatives || Object.keys(recurringInitiatives).length === 0) return null;
    const filterOptions = ["All Months", ...allMonths];
    const monthsToShow = monthFilter === "All Months" ? allMonths : [monthFilter];
    return (
      <div className="section" style={{ width: "100%" }}>
        <InitiativesWrap style={{ padding: "8px 16px", marginBottom: "20px", justifyContent: "space-between" }}>
          <SectionHeader>
            Recurring ({Object.keys(recurringInitiatives).reduce((acc, month) => acc + recurringInitiatives[month].length, 0)})
          </SectionHeader>
          <CommonFilterDropdown options={filterOptions} selectedOption={monthFilter} setSelectedOption={this.handleMonthFilterChange} dropdownWidth="150px" dropdownHeight="200px" customStyles={{ marginLeft: "15px" }} />
        </InitiativesWrap>
        <div className="details" style={{ width: '100%' }}>
          {monthsToShow.map((month) => {
            const monthInitiatives = recurringInitiatives[month] || [];
            const hasInitiatives = monthInitiatives.length > 0;
            const isOpen = openMonths.includes(month);
            return (
              <InterestCard key={`month-${month}`} style={{ backgroundColor: "#FEFEFE99", marginBottom: '20px' }}>
                <MonthHeader isOpen={isOpen} onClick={() => this.toggleMonth(month)}>
                  {month}
                  <div className="dropicon"><NewDropDownIcon color="#F37A65" /></div>
                </MonthHeader>
                {isOpen && hasInitiatives && <div className="dropdown-wrapper">{this.renderOldMonthInitiatives(monthInitiatives, month)}</div>}
                {isOpen && !hasInitiatives && <NoData>No Data Found For {month} Month</NoData>}
              </InterestCard>
            );
          })}
        </div>
      </div>
    );
  }

  renderOldMonthInitiatives = (initiatives, month) => {
    if (!initiatives || initiatives.length === 0) return <NoData>No Data Found For This Month</NoData>;
    const initiativeChunks = this.chunkArray(initiatives, 3);
    return (
      <>
        {initiativeChunks.map((chunk, chunkIndex) => (
          <React.Fragment key={`rec-chunk-${month}-${chunkIndex}`}>
            <InitiativeRow>
              {chunk.map((initiative, idx) => (
                <div className="initiative-cards" key={`rec-${initiative.id || 'noid'}-${month}-${chunkIndex}-${idx}`}>
                  <InitiativeCard background={initiative?.color}>
                    <div className="icon">
                      <img src={`${ImageUrl}/${initiative.initiative_white_icon}`} alt={initiative.initiative_name} onError={(e) => { e.target.src = `${ImageUrl}/default-initiative.png`; }} />
                    </div>
                    <div className="wrap-content">
                      <div className="title">{initiative.initiative_name}</div>
                    </div>
                    <div id="hdm-eyeicon" className="end-container" onClick={(e) => this.handleEyeIconClick(e, initiative)} style={{ cursor: 'pointer' }}>
                      {RecognitionEyeIconNew()}
                    </div>
                  </InitiativeCard>
                </div>
              ))}
            </InitiativeRow>
            {chunkIndex + 1 !== initiativeChunks?.length && <BorderCard />}
          </React.Fragment>
        ))}
      </>
    );
  }

  renderArchivedRecurringSection = () => {
    const { archivedRecurringData, archivedRecurringLoading, archivedOpenMonths, allMonths, archivedMonthFilter } = this.state;
    const hasData = archivedRecurringData && Object.keys(archivedRecurringData).length > 0;
    const filterOptions = ["All Months", ...allMonths];
    const monthsToShow = archivedMonthFilter === "All Months" ? allMonths : [archivedMonthFilter];

    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <SectionHeader style={{ margin: 0 }}>Recurring</SectionHeader>
          {hasData && (
            <CommonFilterDropdown
              options={filterOptions}
              selectedOption={archivedMonthFilter}
              setSelectedOption={this.handleArchivedMonthFilterChange}
              dropdownWidth="150px"
              dropdownHeight="200px"
            />
          )}
        </div>
        {archivedRecurringLoading ? (
          <SkeletonLoder width="100%" height="150px" />
        ) : !hasData ? (
          <NoData>No archived recurring initiatives found</NoData>
        ) : (
          monthsToShow.map((month) => {
            const monthInitiatives = archivedRecurringData[month] || [];
            const hasInitiatives = monthInitiatives.length > 0;
            const isOpen = archivedOpenMonths.includes(month);
            return (
              <WhiteContainer key={month} style={{ marginBottom: '20px' }}>
                <MonthHeader isOpen={isOpen} onClick={() => this.toggleArchivedMonth(month)}>
                  {month}
                  <div className="dropicon"><NewDropDownIcon color="#F37A65" /></div>
                </MonthHeader>
                {isOpen && hasInitiatives && (
                  <CardGrid>
                    {monthInitiatives.map((d, i) => (
                      <ActiveInitiativeCard
                        key={i}
                        details={d}
                        hideBell
                        // onCardClick={(item) =>
                        //   this.props.history?.push(
                        //     `/company/initiative-details/${item?.company_initiative_id || item?.id}`
                        //   )
                        // }
                        isArchived={true}
                      />
                    ))}
                  </CardGrid>
                )}
                {isOpen && !hasInitiatives && (
                  <NoData>No Data Found For {month} Month</NoData>
                )}
              </WhiteContainer>
            );
          })
        )}
      </>
    );
  };

  render() {
    const { activeSubTab, showDetailPopup, detailInitiative } = this.state;

    return (
      <>
        <SubTabBar>
          <SubTab active={activeSubTab === 'completed' ? 1 : 0} onClick={() => this.setState({ activeSubTab: 'completed' })}>
            Completed
          </SubTab>
          <SubTab active={activeSubTab === 'archived' ? 1 : 0} onClick={() => this.setState({ activeSubTab: 'archived' })}>
            Archived
          </SubTab>
        </SubTabBar>

        {activeSubTab === 'completed' && (
          <>
            {this.renderOneTimeSection()}
            {this.renderRecurringNewSection()}
            {/* Old API sections — kept for reference
            <InitiativesWrap>
              {this.renderOldOneOffSection()}
            </InitiativesWrap>
            {this.renderOldRecurringSection()}
            */}
          </>
        )}

        {activeSubTab === 'archived' && (
          <>
            <WhiteContainer>
              <SectionHeader>One-Time</SectionHeader>
              {this.state.archivedLoading ? (
                <SkeletonLoder width="100%" height="150px" />
              ) : (
                <CardGrid>
                  {this.state.archivedData.length > 0 ? (
                    this.state.archivedData.map((d, i) => (
                      <ActiveInitiativeCard
                        key={i}
                        isArchived={true}
                        details={d}
                        hideBell
                        // onCardClick={(item) =>
                        //   this.props.history?.push(
                        //     `/company/initiative-details/${item?.company_initiative_id || item?.id}`
                        //   )
                        // }
                      />
                    ))
                  ) : (
                    <NoData>No archived one-time initiatives found</NoData>
                  )}
                </CardGrid>
              )}
            </WhiteContainer>
            {this.renderArchivedRecurringSection()}
          </>
        )}

        {showDetailPopup && (
          <DetailPopup
            showModal={showDetailPopup}
            detailInitiative={detailInitiative}
            onClose={this.hideShowPopup}
            companyId={this.props.companyInfo.id}
          />
        )}
      </>
    );
  }
}

CompletedInitiative.propTypes = {
  history: PropTypes.object,
  companyId: PropTypes.any,
  companyInfo: PropTypes.any,
  isHealthDash: PropTypes.bool,
  isLibrary: PropTypes.bool,
  setPage: PropTypes.func,
  role: PropTypes.string,
  selectedYearInfo: PropTypes.number,
  selectedYear: PropTypes.number,
  selectedRewardPeriod: PropTypes.object,
};

export default connect(null, null)(CompletedInitiative);
